'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactNative = require('react-native');

var styles = _reactNative.StyleSheet.create({
  swipeout: {
    backgroundColor: '#dbddde',
    overflow: 'hidden'
  },
  swipeoutBtnTouchable: {
    flex: 1
  },
  swipeoutBtn: {
    alignItems: 'center',
    backgroundColor: '#b6bec0',
    flex: 1,
    justifyContent: 'center',
    overflow: 'hidden'
  },
  swipeoutBtnText: {
    color: '#fff',
    textAlign: 'center'
  },
  swipeoutBtns: {
    bottom: 0,
    flex: 1,
    flexDirection: 'row',
    position: 'absolute',
    right: 0,
    top: 0
  },
  swipeoutContent: {},
  colorDelete: {
    backgroundColor: '#fb3d38'
  },
  colorPrimary: {
    backgroundColor: '#006fff'
  },
  colorSecondary: {
    backgroundColor: '#fd9427'
  }
});

exports.default = styles;


//////////////////
// WEBPACK FOOTER
// ./~/react-native-swipeout/dist/styles.js
// module id = 677
// module chunks = 0